// Copyright does not belong to LeanLink AB.

const identity = (value = {}) => value;

export const ActionType = {
  INTENT: 'INTENT',
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

function createActionCreatorFlat(prefix, type, requestPayloadCreator = identity) {
  const BASE_TYPE = `${prefix}/${type}`;

  const INTENT = `${BASE_TYPE}/${ActionType.INTENT}`;
  const REQUEST = `${BASE_TYPE}/${ActionType.REQUEST}`;
  const SUCCESS = `${BASE_TYPE}/${ActionType.SUCCESS}`;
  const FAILURE = `${BASE_TYPE}/${ActionType.FAILURE}`;

  return {
    requestPayloadCreator,
    BASE_TYPE,
    INTENT,
    REQUEST,
    SUCCESS,
    FAILURE,
  };
}

export const createActionCreator =
  prefix =>
    (type, requestPayloadCreator = identity) =>
      createActionCreatorFlat(prefix, type, requestPayloadCreator);

export const intent =
  action =>
    (...args) =>
      ({
        type: action.INTENT,
        baseType: action.BASE_TYPE,
        payload: action.requestPayloadCreator(...args),
        actionType: ActionType.INTENT,
      });

export const request =
  action =>
    (...args) =>
      ({
        type: action.REQUEST,
        baseType: action.BASE_TYPE,
        payload: action.requestPayloadCreator(...args),
        actionType: ActionType.REQUEST,
      });

export const success =
  (action, context) =>
    payload => ({
      type: action.SUCCESS,
      baseType: action.BASE_TYPE,
      payload: {
        ...context,
        ...payload,
      },
      error: null,
      actionType: ActionType.SUCCESS,
    });

export const failure =
  (action, context = {}) =>
    payload => ({
      type: action.FAILURE,
      baseType: action.BASE_TYPE,
      payload: context,
      error: payload,
      actionType: ActionType.FAILURE,
    });
